import React from 'react';
import PropTypes from 'prop-types';
import EditCardProfilePage from './EditCardProfilePage';
import AltContainer from 'alt-container';
import EditCardProfileStore from 'stores/EditCardProfileStore';
import EditScorecardStore from 'stores/EditScorecardStore';
import ScorecardStore from 'stores/ScorecardStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import CardReasonEditStore from 'stores/CardReasonEditStore';
import AuthStore from 'stores/AuthStore';
import CardReasonStore from 'stores/CardReasonStore';
import EditCardProfileActions from 'actions/EditCardProfileActions';
import EditScorecardActions from 'actions/scorecards/EditScorecardActions';
import AdminScorecardActions from 'actions/scorecards/AdminScorecardActions';
import CardProfileActions from 'actions/CardProfileActions';
import DepartmentActions from 'actions/department/DepartmentActions';
import CardReasonEditActions from 'actions/CardReasonEditActions';
import {is} from 'immutable';
import {unsavedMessage} from 'utils/const';
import CardReasonActions from 'actions/CardReasonActions';
import {getQueryParam} from 'utils/getQueryParam';

const scorecardsAsIds = profile =>
  profile.set(
    'scorecards',
    profile.scorecards.map(card => card.id)
  );

export default class EditCardProfilePageContainer extends React.PureComponent {
  componentDidMount() {
    EditCardProfileActions.initializeForm();
    AdminScorecardActions.fetchAllScorecards();
    const idParam = this.props.params.cardsProfileId;
    if (idParam) {
      const id = idParam ? parseInt(idParam) : null;
      CardProfileActions.fetch(id);
    }
    this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }
  routerWillLeave() {
    const {cardProfile, initialCardProfile} = EditCardProfileStore.getState();
    return !is(
      // scorecards modifications get saved separately so only check
      // that the ids match
      scorecardsAsIds(cardProfile),
      scorecardsAsIds(initialCardProfile)
    )
      ? unsavedMessage
      : undefined;
  }
  render() {
    return (
      <AltContainer
        stores={{
          DepartmentFormStore,
          EditCardProfileStore,
          EditScorecardStore,
          ScorecardStore,
          AuthStore,
          CardReasonStore,
          CardReasonEditStore,
        }}
        actions={{
          DepartmentActions,
          CardProfileActions,
          EditCardProfileActions,
          EditScorecardActions,
          AdminScorecardActions,
          CardReasonActions,
          CardReasonEditActions,
        }}>
        <EditCardProfilePage
          hasDepartmentContext={!!this.props.params.departmentId}
          departmentId={this.props.params.departmentId}
          addToDepartment={getQueryParam(this.props.location, 'addToDepartment')}
        />
      </AltContainer>
    );
  }
}
EditCardProfilePageContainer.contextTypes = {
  router: PropTypes.object,
};
